/* eslint-disable import-x/no-import-module-exports */
/* eslint n/global-require: 0 */
/* eslint no-underscore-dangle: 0 */
import { applyMiddleware, compose, createStore } from 'redux'
import { createBrowserHistory } from 'history'
import createSagaMiddleware from 'redux-saga'
import { createReduxHistoryContext } from 'redux-first-history'

import { dataLayerPublish } from '@dhl/datalayer'
import { rootSaga } from './rootSaga'
import { createRootReducer, selectors } from './createRootReducer'
import { loadState } from './loadState'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const devToolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f: any) => f

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
})

const sagaMiddleware = createSagaMiddleware({
  context: {
    selectors,
  },
  onError: (error: Error, { sagaStack }: { sagaStack: string }) => {
    const options = {
      extra: {
        sagaStack,
      },
    }

    dataLayerPublish('ERROR', {
      id: 'sagaMiddleware',
      error,
      options,
    })
  },
})

const persistedState = loadState()

export const store = createStore(
  createRootReducer(routerReducer),
  persistedState,
  compose(applyMiddleware(routerMiddleware, sagaMiddleware), devToolsEnhancer)
)

export const history = createReduxHistory(store)

let task = sagaMiddleware.run(rootSaga)

// @ts-expect-error
if (module.hot) {
  // @ts-expect-error
  module.hot.accept('./createRootReducer', () => {
    const nextCreateRootReducer = require('./createRootReducer').default
    store.replaceReducer(nextCreateRootReducer(history))
  })

  // @ts-expect-error
  module.hot.accept('./rootSaga', () => {
    const nextRootSaga = require('./rootSaga').default
    task.cancel()

    task.toPromise().then(() => {
      task = sagaMiddleware.run(nextRootSaga)
    })
  })
}
